import type { ThemeConfig } from '../types'
import { stardustConfig as generated } from '../../generated/theme-presets'

// Stardust: AURORA DREAM. Everything is a pill. Everything glows. Transitions take
// their sweet time (0.4s) because magic shouldn't be rushed. Ultra-light 400-weight
// headings float above the surface like they're not even trying. Background is alive
// with layered radial gradients — violet, honey, coral — shifting like northern lights
// behind frosted glass. Dashed dividers like constellation lines connecting stars.
// Wide sidebar, generous content, maximum breathing room.
// This is the theme for the kid who documents their adventures by moonlight.
export const stardustConfig: ThemeConfig = generated
